export const Application = {
  MetronAlbum: 'application/vnd.metron.album',
  MetronFolder: 'application/vnd.metron.folder',
  Pdf: 'application/pdf',
  JavaScript: 'application/x-javascript',
  Json: 'application/json',
  SevenZip: 'application/x-7z-compressed',
  Rar: 'application/vnd.rar',
  Zip: 'application/zip',
  MsWord: 'application/msword',
  MsWordX:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  MsExcel: 'application/vnd.ms-excel',
  MsExcelX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  MsPowerPoint: 'application/vnd.ms-powerpoint',
  MsPowerPointX:
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  MsOutlook: 'application/vnd.ms-outlook',
} as const;

export const Text = {
  Html: 'text/html',
  Css: 'text/css',
  Plain: 'text/plain',
} as const;

export const Audio = {
  Wav: 'audio/wav',
  Mp4: 'audio/mp4',
  Mpeg: 'audio/mpeg',
} as const;

export const Video = {
  Mov: 'video/mov',
  QuickTime: 'video/quicktime',
  Mp4: 'video/mp4',
} as const;

export const Image = {
  Png: 'image/png',
  Jpeg: 'image/jpeg',
} as const;
